<template>
    <div class="cb-box" :class="{'compact':isCompact}" v-cloak>
        <h4 class="flex-break-after">{{prompt}}</h4>
        <label v-for="option in options" :key="option" class="cb">
            <input type="radio" required :name="name" :value="option" @change="$emit('update:modelValue', $event.target.value)" />
            <svg viewBox="-5 -4 32 32" class="check"></svg>
            <span>{{option}}</span>
        </label>
    </div>
</template>

<script>
export default {
    name: 'radioSet',
    props: {
        prompt: {required: true, type: String},
        name: {required: true, type: String},
        isCompact: {required: false, type: String},
        options: {required: true, type: Array}
    },
    emits: ['change','update:modelValue']
}
</script>

<style>
.flex-break-after {
    flex-basis: 100%;
}
</style>
